import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["questionKey"];
import { PPUIPageHeader } from 'pricing-pages-ui-components/semantic/PageHeader';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import ProductInfoContainer from '../components/ProductInfoContainer';
import BannerSection from '../components/banners/BannerSection';
import { IntegrationsSection } from '../v2/containers/IntegrationsSection';
import ProductPageSubtitle from '../components/common/ProductPageSubtitle';
import ProductPageTitle from '../components/common/ProductPageTitle';
import CodeSplitEnvWrapper from '../components/common/env/CodeSplitEnvWrapper';
import FallbackErrorBanner from '../components/common/loading/FallbackErrorBanner';
import Faq from '../components/faqs/Faq';
import Question from '../components/faqs/Question';
import { MobileSuiteCardContainer } from '../components/merch-card/card-containers/MobileSuiteCardContainer';
import MobileCurrencyPicker from '../components/mobile/MobileCurrencyPicker';
import MobileDropdownNav from '../components/mobile/MobileDropdownNav';
import { SUITE_PAGE, SUITE_PAGE_CONTENT } from '../constants/ErrorBoundaryNames';
import { DEFAULT } from '../constants/ErrorCauses';
import { FaqsConfig } from '../constants/faqs/FaqsConfig';
import { NavItemEnum } from '../constants/routing/NavItems';
import { useAnchorLinkScroll } from '../hooks/htmlElementHooks';
import { useGlobalLoading } from '../hooks/loadingHooks';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useQueryParamTerm, useQueryParamsEffect } from '../utils/urls/appQueryParamUtilsLegacy';
import { ErrorBoundary } from '../v2/components/error-boundary/ErrorBoundary';
import { ERROR_SEVERITY } from '../v2/components/error-boundary/ErrorSeverity';
import withErrorBoundary from '../v2/components/error-boundary/withErrorBoundary';
import PhoneSupportFooter from '../v2/components/phone-support/PhoneSupportFooter';
import { SCREENS } from '../v2/constants/tracking/Screens';
import { trackPageView } from '../v2/utils/tracking/trackingEventUtils';
import ErrorPage from './ErrorPage';
import MissingInfoFallbackPage from './MissingInfoFallbackPage';
import PhoneSupportMiddle from '../v2/components/phone-support/PhoneSupportMiddle';
import Products from 'merchandise-lib/constants/Product';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileSuitePage = () => {
  useAnchorLinkScroll();
  useDocumentTitle('crmSuite');
  const screen = SCREENS.SUITE;
  const isAppReady = useGlobalLoading();
  useEffect(() => {
    trackPageView({
      screen
    });
  }, [screen]);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    fallback: /*#__PURE__*/_jsx(MissingInfoFallbackPage, {
      navItem: NavItemEnum.SUITE
    }),
    errorBoundaryName: SUITE_PAGE_CONTENT,
    severity: ERROR_SEVERITY.HIGH,
    children: /*#__PURE__*/_jsxs("div", {
      children: [isAppReady && /*#__PURE__*/_jsx(NavMarker, {
        name: "SUITE_PAGE"
      }), /*#__PURE__*/_jsx(MobileCurrencyPicker, {}), /*#__PURE__*/_jsx(MobileDropdownNav, {
        selectedNavItem: NavItemEnum.SUITE
      }), /*#__PURE__*/_jsxs(ProductInfoContainer, {
        children: [/*#__PURE__*/_jsx(BannerSection, {
          screen: screen
        }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(PPUIPageHeader, {
          children: [/*#__PURE__*/_jsx(ProductPageTitle, {
            nonProductIdentifier: NavItemEnum.SUITE
          }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
            nonProductIdentifier: NavItemEnum.SUITE
          })]
        }), /*#__PURE__*/_jsx(MobileSuiteCardContainer, {
          screen: screen
        }), /*#__PURE__*/_jsx(PhoneSupportMiddle, {
          phoneSourceId: "crmsuite-middle",
          screen: screen,
          apiName: Products.CRM_SUITE_STARTER_BUNDLE
        }), /*#__PURE__*/_jsx(IntegrationsSection, {}), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
          publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/company-proof/CompanyProof`),
          publicComponentProps: {
            tab: 'enterprise'
          }
        }), /*#__PURE__*/_jsx(Faq, {
          children: FaqsConfig[NavItemEnum.SUITE].map(_ref => {
            let {
                questionKey
              } = _ref,
              passthroughOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
            return /*#__PURE__*/_jsx(Question, Object.assign({
              questionKey: questionKey
            }, passthroughOptions), questionKey);
          })
        }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
          phoneSourceId: "crmsuite-footer",
          screen: screen,
          apiName: Products.CRM_SUITE_STARTER_BUNDLE
        })]
      })]
    })
  });
};
export default withErrorBoundary(MobileSuitePage, {
  FallbackComponent: () => /*#__PURE__*/_jsx(ErrorPage, {
    errorCause: DEFAULT
  }),
  errorBoundaryName: SUITE_PAGE,
  severity: ERROR_SEVERITY.HIGH
});